import api from './api';
import types from './mutation-types';
import state from './state';
// import moment from 'moment';
// import _ from 'lodash';

// const dateFormat = ts => {
// 	return moment(ts).format('YYYY-MM-DD');
// };

export default {
	/* 추가버튼 클릭시 */
	defaultAssign_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, {
			key,
			value
		});
	},

	/* 폼등록 팝업화면에서 키 입력시 세팅하는 함수 */
	setModalValue_({ commit }, { key, value }) {
		commit(types.SET_MODAL_VALUE, { key, value });
	},

	/* 업로드 폼 저장관련 */
	addUploadForm_({ commit }, { formData }) {
		return api
			.addUploadForm({ formData })
			.then(data => {
				if (data.header.code === 0) {
					return data.header;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	getUploadFormList_({ commit }, params = { gqmsSeq, gqmsTitle, gqmsConts, currentPage, pageUnit }) {
		return api
			.getUploadFormList(params)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_SEARCH_PARAM, params);
					const { currentPage, pageUnit, totalSize } = data.body.pagingInfo;
					commit(types.DEFAULT_ASSIGN, {
						key: 'groups',
						value: { currentPage, pageUnit, totalSize }
					});
					commit('setUploadFormList', data.body.resultList);
					// commit(types.SET_OPTION_PLANT_LIST, {
					// 	key: 'value',
					// 	list: data.body
					// });
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	getUpdateFormList_({ commit }, params = { gqmsSeq, gqmsTitle, gqmsConts, currentPage, pageUnit }) {
		return api
			.getUpdateFormList(params)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_OPTION_PLANT_LIST, {
						key: 'value',
						list: data.body
					});
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	// 수정 저장시 사용
	saveUploadForm_({ commit }, { formData }) {
		return api
			.saveUploadForm({ formData })
			.then(data => {
				if (data.header.code === 0) {
					return data.header;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	searchCommCdTypeOptions_({ state, dispatch, commit }) {
		return api
			.selectCommCdTypeList({ ...state.searchParam, currentPage: 0, pageUnit: 0 })
			.then(({ body: { result }, header }) => {
				result.forEach(row => delete row.totalSize);
				dispatch('setCommCdTypeOptions_', result);
				return result;
			})
			.catch(e => console.error(e));
	},
	setCommCdTypeOptions_({ state, commit }, rows) {
		const value = [{ label: 'ALL', value: 'ALL' }].concat(rows.map(({ commCdType }) => ({ label: commCdType, value: commCdType })));
		commit(types.SET, {
			key: 'commCdTypeOptions',
			value
		});
		return value;
	},
	searchCommCd_({ state, commit }, payload) {
		const { commCdType, init, currentPage = 1, pageUnit = 10 } = payload;
		//console.log('searchCommCd_ 시작 ');
		return api
			.selectCommCdList({ commCdType, currentPage, pageUnit })
			.then(({ body: { pagingInfo, result } }) => {
				result.forEach(row => delete row.totalSize);
				commit(types.SET, { key: 'commCdRows', value: init || result });
				commit(types.SET, { key: 'commCdPagingInfo', value: pagingInfo });
				return result;
			})
			.catch(e => console.error(e));
	},
	setUseYnOptions_({ state, commit }, rows) {
		commit(types.SET, {
			key: 'useYnOptions',
			value: [{ label: 'Select', value: '' }].concat(rows.map(({ commCd }) => ({ label: commCd, value: commCd })))
		});
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	onChangeSearchParam_({ commit }, { key, value }) {
		return commit('setSearchParam', { key, value });
	},
	onChangeUserPopupSearchParam_({ commit }, { key, value }) {
		return commit('setUserPopSearchParam', { key, value });
	},
	getUseYnList_({ commit }, { plantCd }) {
		return api.getUseYnList(plantCd, 'USE_YN').then(res => {
			const value = res.body.map(({ commCd, commCdName }) => ({ label: commCd, value: commCd }));
			commit(types.SET, { key: 'useYnOptions', value });
			return value;
		});
	},
	select_({ commit, state: { searchParams, pagingInfo } }, newPagingInfo) {
		//console.log('select_ 함수 시작');
		return api.select({ ...searchParams, ...pagingInfo, ...newPagingInfo }).then(res => {
			const { resultList, pagingInfo } = res.body;
			//commit('setTableInfoList', result !== null && result !== undefined ? result.resultList : null);
			//console.log('resultList ::::: ', resultList);
			/* */
			const rows = resultList.map(({ gqmsSeq, gqmsTitle, gqmsConts, ...row }) => ({
				...row,
				gqmsSeq,
				gqmsTitle,
				gqmsConts
			}));

			//console.log('select_ 진행 후 넘어온 데이터', rows);
			//commit('setTableInfoList', res.body.resultList);
			commit('setUploadFormList', rows);
			commit(types.SET, { key: 'pagingInfo', value: pagingInfo });
			return rows;
		});
	},

	/* 추가버튼 팝업관련 */
	closeModal_({ commit }) {
		commit(types.DEFAULT_ASSIGN, {
			key: 'UploadFormModalValue',
			value: {
				flg: 'I',
				gqmsSeq: '',
				gqmsTitle: '',
				gqmsConts: '1. 테스트 파일업로드 : ',
				fileId: '',
				file2Id: '',
				imgId1: '',
				imgFile1: [],
				imgId2: '',
				imgFile2: [],
				fileList: [],
				regId: ''
				// flg: 'I',
				// gqmsSeq: '',
				// gqmsTitle: '',
				// gqmsConts: '1. 테스트 파일업로드 : ',
				// fileId: '',
				// file2Id: '',
				// imgId1: '',
				// imgId2: '',
				// fileList: [],
				// regId: ''
			}
		});

		commit(types.DEFAULT_ASSIGN, {
			key: 'UploadFormModal',
			value: false
		});
	},
	addUploadForm_({ commit }, { formData }) {
		// 업로드폼에 있는 데이터 저장
		return api
			.addUploadForm({ formData })
			.then(data => {
				if (data.header.code === 0) {
					return data.header;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},
	/* 상세팝업 관련시작 */
	setDetailValue_({ commit }, { key, value }) {
		commit(types.SET_DETAIL_VALUE, { key, value });
	},
	closeDetail_({ commit }) {
		commit(types.DEFAULT_ASSIGN, {
			key: 'UploadFormDetailValue',
			value: {
				// gqmsSeq: '',
				// gqmsTitle: '',
				// gqmsConts: '',
				// fileId: '',
				// file2Id: '',
				// imgId1: '',
				// imgFile1: [],
				// imgId2: '',
				// imgFile2: [],
				// fileList: [],
				// fileInfo: [],
				// regId: ''
				gqmsSeq: '',
				gqmsTitle: '',
				gqmsConts: '',
				fileId: '',
				file2Id: '',
				imgId1: '',
				imgFile1: [],
				imgId2: '',
				imgFile2: [],
				fileList: [],
				fileInfo: [],
				regId: ''
			}
		});

		commit(types.DEFAULT_ASSIGN, {
			key: 'UploadFormDetail',
			value: false
		});
	},
	//이미지를 보여주기 위한 다운로드
	imgDownload_({ state, commit }, params = { no, seq }) {
		return api
			.fileDownload({ params })
			.then(response => {
				//console.log('response', response);
				const filename = decodeURIComponent(response.headers.filename);
				const filetype = decodeURIComponent(filename.substring(filename.lastIndexOf('.') + 1));
				//console.log('filetype', filetype.toUpperCase());
				let url = '';
				if ('|JPG|PNG|GIF|'.indexOf(filetype.toUpperCase()) > -1)
					url = window.URL.createObjectURL(new Blob([response.data], { type: 'image/png' }));

				return { name: filename, url };
			})
			.catch(error => {
				throw error;
			});
	},

	//실제 파일명을 클릭했을때 다운로드 하기 위한 함수
	fileDownload_({ state, commit }, params = { fileId, fileSeq }) {
		return api
			.fileDownload({ params })
			.then(response => {
				//console.log('response', response);
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				const filename = decodeURIComponent(response.headers.filename);
				link.setAttribute('download', filename);
				//console.log('filename', filename);
				document.body.appendChild(link);
				link.click();
			})
			.catch(error => {
				throw error;
			});
	},

	// 상세페이지 에서 삭제버튼 클릭시
	delUploadForm_({ rootState }, { params }) {
		//console.log('delUploadForm_');
		return api
			.delUploadForm({ params })
			.then(data => {
				if (data.header.code === 0) {
					return data.header;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	getSelectOne_({ state, commit }, payload) {
		const gqmsSeq = payload;
		//console.log('단건조회 테스트', gqmsSeq);
		return api
			.selectOne_({ gqmsSeq })
			.then(data => {
				//console.log('data.body.resultData ::: ', data.body.resultData);
				//console.log('data.body.fileList ::: ', data.body.fileList);
				if (data.header.code === 0) {
					return data.header;
				} else {
					throw new Error(data.header.message);
				}
			})
			.catch(error => {
				throw error;
			});
	}
};
